import React, {PureComponent} from 'react'
import {TimelineMax, Power1} from 'gsap'

const svgPathLengths = [1140, 430, 325, 412, 414, 183, 290, 154, 419, 177]

class LogoSpinner extends PureComponent {

    componentDidMount() {
        const {animate} = this.props;
        if(animate) this._animate();
    }

    componentDidUpdate() {
        if(!this._ref || ! this._ref.children) return;
        const {animate} = this.props;
        if(animate)
            this._animate();
    }

    _animate = () => {
        if(!this._ref || ! this._ref.children) return;

        const {repeat=false, speed=0.1} = this.props;

        this._tl = new TimelineMax({repeat:repeat ? 10000000 : 0, repeatDelay:0.5});
        var lettersGroup = this._ref.children[0];
        var eclipsGroup = this._ref.children[1];

        for(var i=0; i<svgPathLengths.length; i++) {
            this._tl.set(lettersGroup.children[i], {strokeDasharray: svgPathLengths[i], strokeDashoffset: svgPathLengths[i]});
        }
        this._tl.set(eclipsGroup, {opacity: 0});

        //add a from() tween at the beginning of the timline
        this._tl.to(lettersGroup.children[0], speed*4, {strokeDashoffset: 0, ease: Power1.easeIn})
            .to(lettersGroup.children[1], speed, {strokeDashoffset: 0})
            .to(lettersGroup.children[2], speed, {strokeDashoffset: 0})
            .to(lettersGroup.children[3], speed*2, {strokeDashoffset: 0})
            .to(lettersGroup.children[4], speed*2, {strokeDashoffset: 0})
            .to(lettersGroup.children[5], speed, {strokeDashoffset: 0})
            .to(lettersGroup.children[6], speed, {strokeDashoffset: 0})
            .to(lettersGroup.children[7], speed, {strokeDashoffset: 0})
            .to(lettersGroup.children[8], speed*2, {strokeDashoffset: 0})
            .to(lettersGroup.children[9], speed, {strokeDashoffset: 0})
            .to(eclipsGroup, 0.2, {opacity: 1}, `-${speed}s`);

    }

    componentWillUnmount() {
        if(this._tl) {
            this._tl.kill();
        }
    }

    _setRef = (ref) => this._ref = ref;

    render() {
        const {className, width=120, height=48} = this.props;
        return <svg x="0px" y="0px" viewBox="0 0 1000 326" className={className} width={width} height={height} ref={this._setRef}>
            <g fill="none" stroke="currentColor" strokeWidth="10.8761" fillRule="evenodd" strokeLinecap="round" strokeMiterlimit="10">
                <path d="M368.1,19.5C286.5-2.7,132.3,46.6,133.5,87.4c1.2,38.8,72.9,31.9,99.3,32.1c25.3,0.2,88.9-2.7,82.3-21.6
                    C303.7,65.6,17.9,160.6,15.3,262.7c-0.5,20.4,24,45.7,81.6,45.2c77.3-0.7,138-41.1,180.3-80.6"/>
                <path d="M419.4,142c-55.5-3.2-117.2,40.8-117.2,67.9c0,6.8,3.4,13.5,13.5,13.5c16.9,0,97-29.3,206-152.1"/>
                <path d="M496.8,98.2c-22.8,27.1-119.1,122.1-92.3,125.1c45.4,5.1,118.5-60.9,135.4-81.1"/>
                <path d="M540,142.2c-13.5,16.9-75.6,81.1-41.9,81.1S613,150.6,613,150.6c36-39.6,83.1-81,119.1-120.6"/>
                <path d="M732.1,30c0,0-68.4,61.5-109,108.9c-40.5,47.3-57.5,60.5-57.5,70.6s6.8,13.5,16.9,13.5
                    c23.6,0,98.3-60.5,115.2-80.8"/>
                <path d="M697.7,142.2C684.2,159.1,623,223,656.8,223c18.5,0,43.6-21.7,64.8-41"/>
                <path d="M805.4,142.2c-34.5-6-97.4,38.6-96.1,65.3c0.6,12.5,17.3,13.7,32.9,10.7c38.9-7.3,108.2-64.3,93.7-72.7"/>
                <path d="M835.8,145.6c-17.1-3.4-29.5,37.2-12.2,38.9c31.5,3.1,63.3-28.2,83.2-49"/>
                <path d="M906.8,135.5c0,0-78.2,87.5-68.1,87.5c10.1,0,53.1-63.2,95.5-75.7c72.5-21.4-52.8,62.8-8.7,75.7
                    c16.5,4.9,43-6.1,59.2-17.6"/>
                <path  d="M801.4,64.9c-1.1-0.4-128.4,4.3-175.8,10.4" strokeLinejoin="round"/>
            </g>
            <g fill="currentColor" >
                <ellipse cx="561.1" cy="113.7" rx="5.6" ry="5.6"/>
                <ellipse cx="719.1" cy="113.7" rx="5.6" ry="5.6"/>
            </g>
        </svg>
    }
}

export default LogoSpinner





// WEBPACK FOOTER //
// ./src/components/Widgets/LogoSpinner.js